import script from "./InspectionReports.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionReports.vue?vue&type=script&setup=true&lang=js"

import "./InspectionReports.vue?vue&type=style&index=0&id=5ed04965&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed04965"]])

export default __exports__